import { montserrat, neueMachina } from '../../fonts'

export const fonts = {
  heading: neueMachina.style.fontFamily,
  body: montserrat.style.fontFamily,
}
